<template>
  <div class="ui top fixed menu" id="header">
    <div v-if="client.authenticated" class="ui simple dropdown item borderless" id="show_sidebar2" @click="show_sidebar2">
      <i class="bars icon"></i>
      <PageLinks class="ui sidebar inverted vertical menu" id="sidebar2" @click="hide_sidebar2"/>
    </div>
    <router-link to="/files" class="header item borderless logolink">
      <img class="ui logo" src="../assets/logo.png" />
    </router-link>
    <CompatibilityIndicator v-if="!browser_ok" />
    <Indicator v-if="client.quota" class="lg-only" />
    <div class="right item borderless">
      <a href="https://uki6nd.fanqier.cn/f/9swbk16e" target="blank" class="hidden md:block">
        <span class="mr-1">
          意见反馈
        </span>
        <i class="external alternate icon"></i>
      </a>
    </div>
    <router-link v-if="!authenticated" to="/register" class="item borderless">
      <strong>
        注册
      </strong>
    </router-link>
    <router-link to="/login" class="item borderless" v-if="!authenticated">
      <strong>
        登录
      </strong>
    </router-link>
    <div v-else class="ui simple dropdown item borderless" id="user-dropdown">
      <span class="hidden md:inline mr-2">
        {{ greeting }}
      </span>
      <span v-if="display_name">
        {{ display_name }}
      </span>
      <i class="dropdown icon"></i>
      <div class="left menu">
        <div class="quota item">
          <Indicator v-if="client.quota" />
        </div>
        <a class="item" @click="$router.push({ name: 'settings' })">
          <i class="wrench icon"></i>
          设置
        </a>
        <a class="item" @click="$router.push({ name: 'orders' })">
          <i class="credit card outline icon"></i>
          我的订单
        </a>
        <div class="divider"></div>
        <a class="item" @click="logout">
          <i class="sign out icon"></i>
          退出登录
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PageLinks from "./pagelinks.vue"
import Indicator from './indicator.vue'
import CompatibilityIndicator from './compatibility-indicator.vue'

export default {
  name: 'Header',
  props: [],
  components: {
    PageLinks,
    Indicator,
    CompatibilityIndicator,
  },
  data: function() {
    return {
      greeting: "欢迎",
    };
  },
  computed: {
    display_name() {
      return this.client.display_name;
    },
    authenticated() {
      return this.$store.getters.authenticated;
    },
  },
  methods: {
    show_sidebar2() {
      this.$("#sidebar2").sidebar("show");
    },
    hide_sidebar2() {
      console.log("page links click");
      this.$("#sidebar2").sidebar("hide");
    },
    refresh_greeting() {
      var t = new Date();
      var h = t.getHours();
      var r;
      if (h < 5) {
        r = "注意休息";
      } else if (h < 12) {
        r = "早上好";
      } else if (h < 13) {
        r = "中午好";
      } else if (h < 19) {
        r = "下午好";
      } else if (h < 22) {
        r = "晚上好";
      } else {
        r = "早点休息";
      }
      this.greeting = r;
    },
    usage_dropdown_shown() {
      this.$gtag.event('header-show-usage', {
        event_category: 'user-action',
      });
    },
    home() {
      return { name: "files" };
    },
    logout() {
      this.$store.commit('logout');
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    setTimeout(() => {
      this.refresh_greeting();
    }, 10000);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#left-menu > div {
  overflow-y: scroll;
}
#sidebar2 {
  width: 200px !important;
  padding-top: 2rem;
}

.lg #show_sidebar2 {
  display: none;
}
img.logo {
  height: 22px;
}

.lg img.logo {
  margin-left: 20px;
}

.sm a.logolink {
  padding-left: 5px !important;
  padding-right: 0 !important;
}
#app.lg #user-dropdown .quota {
  display: none;
}
.lg-only {
  display: none !important;
}
#app.lg .lg-only {
  display: flex !important;
}
</style>
